import React, { useEffect, useState } from 'react'
// Component
import SpinnerInlineComponent from '../../../../components/SpinnerInlineComponent'
// Styled Component
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'
import { ModalCreateSignDocWrapper } from './PopupCreateSignDocStyled'
// Ant design
import {
  BankOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileTextOutlined,
  PlusOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  Menu,
  message,
  Row,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
// Other
import { inject, observer } from 'mobx-react'
import { blue, redPrimary, yellowPrimary } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import SelectGroupPopup from '../../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import { ASSIGNEE_TYPE } from '../../../../constants'
import validator from '../../../../validator'
import { SelectList } from '../../../MissionCreatePage/MissionCreatePageStyled'
import DraggerUploadButton from '../../../../components/Common/DraggerUploadButton'

const PopupCreateSignDoc = props => {
  const {
    loadingAnimationStore,
    electronicDocumentStore,
    fileStore,
    isVisiblePopupCreateSignDoc,
    handleClosePopupCreateSignDoc,
    selectPeopleStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])
  const [electronicDocument, setElectronicDocument] = useState([])

  const [leaderList, setLeaderList] = useState([])
  const [combinerList, setCombinerList] = useState([])

  useEffect(() => {
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({ file_upload: undefined })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const onFinish = async values => {
    const uploadFileList = fileList
      ? fileList
          .filter(
            (elem, index, fileList) =>
              fileList.findIndex(file => file.name === elem.name) === index
          )
          .map(file => file.originFileObj)
          .filter(file => file)
      : []
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const combinerListData = combinerList.map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const leaderData = leaderList.map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    if (leaderList.length === 0)
      return message.info('Bạn chưa chọn lãnh đạo ký duyệt!')
    try {
      loadingAnimationStore.showSpinner(true)
      const responseAttachments = await Promise.all(batchUploadArr)
      const formData = new FormData()
      formData.append('file', electronicDocument[0].originFileObj)
      const responseSignDoc = await fileStore.uploadFile(formData)
      const submitData = {
        title: values.title,
        attachments: responseAttachments.map(response => response.data.file_id),
        file_id: responseSignDoc.data.file_id,
        assignees: [...leaderData, ...combinerListData],
      }
      await electronicDocumentStore.createElectronicDocument(submitData)
      form.resetFields()
      setElectronicDocument([])
      setFileList([])
      selectPeopleStore.clearSelected()
      electronicDocumentStore.clearFilter()
      await electronicDocumentStore.getElectronicDocumentList()
      handleClosePopupCreateSignDoc()
      message.success('Tạo trình ký thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleChangeElectronicDoc = info => {
    if (info.fileList.length === 0) return setElectronicDocument([])
    setElectronicDocument([info.fileList[info.fileList.length - 1]])
  }

  const handleClose = () => {
    form.resetFields()
    setElectronicDocument([])
    setFileList([])
    selectPeopleStore.clearSelected()
    handleClosePopupCreateSignDoc()
  }

  return (
    <ModalCreateSignDocWrapper
      visible={isVisiblePopupCreateSignDoc}
      footer={null}
      onCancel={handleClose}
      title={'Tạo trình ký văn bản'}
      width={650}
      style={{ top: 60 }}
      wrapClassName="custom-modal-wrapper">
      <SpinnerInlineComponent />
      <Form onFinish={onFinish} layout={'vertical'} name={'form'} form={form}>
        <Form.Item
          label={'Tiêu đề:'}
          name={'title'}
          rules={[
            { required: true, message: ' Vui lòng nhập tiêu đề trình ký!' },
            { validator: validator.validateInputString },
            { max: 200, message: 'Tiêu đề không được dài quá 200 kí tự' },
          ]}>
          <Input placeholder={'Nhập tiêu đề...'} className="h-40" />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <label
              style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
              <span style={{ color: redPrimary, marginRight: 4 }}>*</span>Lãnh
              đạo ký duyệt:
            </label>
            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.LEADER)
                  }
                />
              </Tooltip>
            </Space>
            <SelectList>
              {leaderList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </SelectList>
          </Col>

          <Col span={12}>
            <label
              style={{ display: 'inline-block', margin: '15px 12px 25px 0' }}>
              Người phối hợp:
            </label>

            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  className="select-user-icon-btn"
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
              <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                <Button
                  className="select-user-icon-btn"
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary }}
                  onClick={() =>
                    handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                  }
                />
              </Tooltip>
            </Space>

            <SelectList>
              {combinerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                </Tag>
              ))}
            </SelectList>
          </Col>

          <Col span={24}>
            <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
              <Tabs.TabPane tab="Tài liệu trình ký" key="1" forceRender>
                <Form.Item
                  name={'electronic_document'}
                  rules={[
                    {
                      required: true,
                      message: ' Vui lòng chọn tài liệu trình ký!',
                    },
                  ]}>
                  <Upload.Dragger
                    valuePropName={'fileList'}
                    fileList={fileList}
                    multiple={false}
                    beforeUpload={() => false}
                    onChange={handleChangeElectronicDoc}
                    showUploadList={false}
                    accept={'.doc,.docx,application/pdf'}
                    className="custom-dragger-upload">
                    <DraggerUploadButton acceptFileLabel="DOC, DOCX, PDF" />
                  </Upload.Dragger>
                </Form.Item>
                <SignDocumentList>
                  {electronicDocument.map((file, index) => {
                    return (
                      <FileItem key={file.uid}>
                        <span>
                          <FileTextOutlined style={{ marginRight: 5 }} />
                          {file.name}
                        </span>
                        <FileAction>
                          <Tooltip title={'Xóa'}>
                            <Button
                              type={'text'}
                              icon={
                                <DeleteOutlined style={{ color: redPrimary }} />
                              }
                              onClick={() => setElectronicDocument([])}
                            />
                          </Tooltip>
                        </FileAction>
                      </FileItem>
                    )
                  })}
                </SignDocumentList>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tài liệu đính kèm" key="2" forceRender>
                <Form.Item name={'file'}>
                  <Upload.Dragger
                    valuePropName={'fileList'}
                    fileList={fileList}
                    multiple={true}
                    beforeUpload={() => false}
                    onChange={handleChangeFile}
                    showUploadList={false}
                    className="custom-dragger-upload">
                    <DraggerUploadButton />
                  </Upload.Dragger>
                </Form.Item>
                <SignDocumentList>
                  {fileList.map((file, index) => {
                    return (
                      <FileItem key={file.uid}>
                        <span>
                          <FileTextOutlined style={{ marginRight: 5 }} />
                          {file.name}
                        </span>
                        <FileAction>
                          <Tooltip title={'Xóa'}>
                            <Button
                              type={'text'}
                              icon={
                                <DeleteOutlined style={{ color: redPrimary }} />
                              }
                              onClick={() =>
                                setFileList(
                                  fileList.filter(el => el.uid !== file.uid)
                                )
                              }
                            />
                          </Tooltip>
                        </FileAction>
                      </FileItem>
                    )
                  })}
                </SignDocumentList>
              </Tabs.TabPane>
            </Tabs>
          </Col>
        </Row>
        <div className="custom-modal-footer" style={{ marginTop: 16 }}>
          <Button
            type="default"
            onClick={handleClose}
            htmlType="button"
            className="custom-ant-button w-160">
            Hủy bỏ
          </Button>
          <Button
            htmlType={'submit'}
            type={'primary'}
            className="custom-ant-button w-160">
            Tạo trình ký
          </Button>
        </div>
      </Form>

      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </ModalCreateSignDocWrapper>
  )
}

PopupCreateSignDoc.propTypes = {}

export default inject(
  'loadingAnimationStore',
  'authenticationStore',
  'fileStore',
  'electronicDocumentStore',
  'selectPeopleStore'
)(observer(PopupCreateSignDoc))
